import { gql } from "@apollo/client";

export const CREATE_JUSTIFICACION_CONDICIONAL_PEDIDO = gql`
  mutation createJustificacionCondicionalPedido(
    $idEvaluacion: Int!
    $idOrdenPedido: Int!
    $estadoPEnvio: Boolean!
    $diasCondicional: Int!
    $diasMaxFacturacionCliente: Int!
    $contratosCO: String!
  ) {
    createJustificacionCondicionalPedido(
      input: {
        idEvaluacion: $idEvaluacion
        idOrdenPedido: $idOrdenPedido
        estadoPEnvio: $estadoPEnvio
        diasCondicional: $diasCondicional
        diasMaxFacturacionCliente: $diasMaxFacturacionCliente
        contratosCO: $contratosCO
      }
    ) {
      idJustificacion
    }
  }
`;